module.exports = __webpack_public_path__ + "img/dice-4-fill.2e847eac.svg";